import { DATA_LOADED, STORE_TT_DATA, STORE_TT_FILE } from "../actions/trade-trust";

const initialState = {
	data: null,
	file: null,
	hasLoadedData: false,
};

const storeTTReducer = (state = initialState, action) => {
	switch (action.type) {
		case STORE_TT_DATA:
			return {
				...state,
				data: action.payload,
			};
		case STORE_TT_FILE:
			return {
				...state,
				file: action.payload,
			};
		case DATA_LOADED:
			return {
				...state,
				hasLoadedData: true,
			};
		default:
		return state;
	}
};

export default storeTTReducer;
